import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();
const AddProduct = () => {
    const handleSubmit = () => {
        toast.success("Product is added");
    };
    return(
        <div className="mb-4" style={{paddingTop: "50px",maxWidth: "150%"}}>
           <form action="">
                <div className="form-row">
                    <div className="col">
                    <label htmlFor="Name" style={{paddingBottom: "37px"}}><h6>Name     :</h6></label>
                       <input type="text" className="form-control" placeholder="name"  required/>
                    </div>
                    <div className="col">
                    <label htmlFor="Detail"><h6>Detail(if Number:1 / Quantity Default =1 kg/1 lr) </h6></label>
                        <input  className="form-control" type="text" placeholder="Detail"/>
                    </div>
                    <div className="col">
                    <label htmlFor="Price" style={{paddingBottom: "37px"}}><h6>Price of 1 No/Quantity</h6></label>
                        <input  className="form-control" type="text" placeholder="Price"  required/>
                    </div>
                    <div className="col">
                        <label htmlFor="producttime"><h6>Is this product/service takes time(if yes:Give avg) </h6></label>
                        <input type="time" id="producttime"  className="form-control"/>
                    </div>
                    <div className="col">
                        <label htmlFor="productcount"><h6>Is this product/service is limited?(if yes : Give count) </h6></label>
                        <input type="number" id="productcount"  className="form-control"/>
                    </div>
                    <div className="col" style={{paddingBottom: "37px"}}>
                    <button onClick={handleSubmit} type="submit" className="btn btn-primary">Add</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddProduct;